var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69323 1.1452L4.03289 4.80554C3.92527 4.91316 3.92527 5.08728 4.03289 5.19446L7.69323 8.8548C7.90016 9.06173 7.90016 9.39727 7.69323 9.60463L7.45306 9.84481C7.24614 10.0517 6.91059 10.0517 6.70323 9.84481L2.24099 5.38257C2.02969 5.17127 2.02969 4.82873 2.24099 4.61743L6.70323 0.155194C6.91015 -0.0517313 7.2457 -0.0517313 7.45306 0.155194L7.69323 0.395366C7.90016 0.602292 7.90016 0.937834 7.69323 1.1452Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/ArrowLeftIcon.5f055d5cf0d80152283fa3bfb34a031f.svg";
export { ForwardRef as ReactComponent };